<template>
  <div>
    <form @submit.prevent="$emit('filter', 'filterStory')">
      <b-sidebar id="sidebar-right" backdrop shadow title="Filtros" right>
        <div class="px-3 py-2">
          <div class="col-12" style="margin-top: 30%">
            <div class="button-modal">
              <div class="col-11">
                <p style="margin: 0">Últimas 24h</p>
              </div>
              <div class="col-1">
                <input
                  @click="clickVinteQuatro()"
                  type="checkbox"
                  v-model="vintequatro"
                />
              </div>
            </div>
          </div>
          <div class="col-12">
            <div class="button-modal">
              <div class="col-11">
                <p style="margin: 0">Últimos 7 dias</p>
              </div>
              <div class="col-1">
                <input @click="clickSete()" type="checkbox" v-model="sete" />
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="button-modal">
              <div class="col-11">
                <p style="margin: 0">Últimos 30 dias</p>
              </div>
              <div class="col-1">
                <input
                  @click="clickTrinta()"
                  type="checkbox"
                  v-model="trinta"
                />
              </div>
            </div>
          </div>

          <div class="col-12">
            <div class="button-modal">
              <div class="col-11">
                <p style="margin: 0">Personalizado</p>
              </div>
              <div class="col-1">
                <input
                  @click="clickPerso()"
                  type="checkbox"
                  v-model="personalizado"
                />
              </div>
            </div>
          </div>
          <div style="text-align: center" v-show="personalizado">
            <v-date-picker
              mode="date"
              v-model="date"
              is-range
              :max-date="new Date()"
              style="
                margin-bottom: 8px;
                border: none;
                background-color: var(--blue-light);
                z-index: 0;
              "
            />
          </div>
        </div>

        <template #footer>
          <div class="d-flex align-items-center px-3 py-2 col-12">
            <div class="col-6">
              <button
                type="reset"
                class="p-filtro border-0 w-100"
                style="outline: none; background-color: transparent"
                @click="
                  $emit('clear', { type: '24', date: range }), limparFiltros
                "
                v-b-toggle.sidebar-right
              >
                Limpar filtros
              </button>
            </div>
            <div class="col-6">
              <button
                v-b-toggle.sidebar-right
                class="button-filtrar"
                type="submit"
              >
                Filtrar
              </button>
            </div>
          </div>
        </template>
      </b-sidebar>
    </form>
  </div>
</template>
<script>
import moment from "moment/moment";

export default {
  props: {
    filtros: {
      type: Array,
    },
  },
  data() {
    return {
      range: {
        end: moment().toISOString(),
        start: moment().toISOString(),
      },
      date: {
        start: "",
        end: "",
      },
      personalizado: false,
      sete: false,
      trinta: false,
      vintequatro: false,
    };
  },

  computed: {
    dateFormatStart() {
      let data =
        this.date.start != undefined ? new Date(this.date.start) : new Date();
      let day = data.getDate();
      let month = data.getMonth();
      let year = data.getFullYear();
      let resultado = new Date(year, month, day).toISOString();
      return resultado;
    },
    dateFormatEnd() {
      let data =
        this.date.end != undefined ? new Date(this.date.end) : new Date();
      let day = data.getDate();
      let month = data.getMonth();
      let year = data.getFullYear();
      let resultado = new Date(year, month, day).toISOString();
      return resultado;
    },
  },

  watch: {
    sete(newValue) {
      if (newValue) {
        this.range.start = moment().subtract(7, "days").toISOString();
        this.range.end = moment().toISOString();
        this.$emit("onUpdateSete", { type: "7", date: this.range });
      }
    },
    trinta(newValue) {
      if (newValue) {
        this.range.start = moment().subtract(1, "month").toISOString();
        this.range.end = moment().toISOString();
        this.$emit("onUpdateTrinta", { type: "30", date: this.range });
      }
    },
    vintequatro(newValue) {
      if (newValue) {
        this.range.start = moment().subtract(1, "days").toISOString();
        this.range.end = moment().toISOString();
        this.$emit("onUpdateVinteQuatro", { type: "24", date: this.range });
      }
    },
    date(newValue) {
      if (newValue) {
        this.date.start = this.dateFormatStart;
        this.date.end = this.dateFormatEnd;

        this.$emit("onUpdatePersonalizado", {
          type: "personalizado",
          date: this.date,
        });
      }
    },
  },

  methods: {
    //TODO: Migrar para dash e resetar as prop dateEndFilter e dateStartFilter
    limparFiltros() {
      this.personalizado = false;
      this.sete = false;
      this.trinta = false;
      this.vintequatro = false;
    },
    clickTrinta() {
      this.personalizado = false;
      this.sete = false;
      this.trinta = true;
      this.vintequatro = false;
    },
    clickVinteQuatro() {
      this.personalizado = false;
      this.sete = false;
      this.trinta = false;
      this.vintequatro = true;
    },
    clickSete() {
      this.personalizado = false;
      this.sete = true;
      this.trinta = false;
      this.vintequatro = false;
    },
    clickPerso() {
      this.personalizado = true;
      this.sete = false;
      this.trinta = false;
      this.vintequatro = false;
    },
    disabledAfterToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date > today;
    },
  },
};
</script>

<style>
.button-modal {
  background: #f0f2f8;
  border-radius: 8px;
  width: 100%;
  padding: 12px;
  display: flex;
  margin-top: 3%;
}

.p-filtro {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 19px;
  align-items: center;
  text-align: center;
  color: #2485ea;
  cursor: pointer;
}

.button-filtrar {
  background: #2485ea;
  border-radius: 8px;
  font-family: "Roboto";
  font-style: normal;
  font-weight: 450;
  font-size: 16px;
  line-height: 16px;
  text-align: center;
  color: #ffffff;
  padding: 10px;
  border: none;
  width: 100%;
}

.close {
  border: none;
  background: transparent;
}
</style>
